package repdb

import kotlin.Long

public actual abstract class CompositePkDao {
  public actual abstract fun insert(entity: CompositePkEntity)

  public actual abstract fun update(entity: CompositePkEntity)

  public actual abstract fun delete(entity: CompositePkEntity)

  public actual abstract fun findByPKs(code1: Long, code2: Long): CompositePkEntity?
}
